import { apiClient } from './api/apiClient';
import type { ApiResponse } from '../types';

export interface CustomerLookup {
  customerId: number;
  fullName: string;
  email: string;
  loyaltyCode: string;
  pointsBalance: number;
  customerLoyaltyId: number;
}

export interface PointsTransactionResult {
  id: number;
  points: number;
  type: string;
  description?: string;
  createdAt: string;
}

export const loyaltyService = {
  lookupCustomer: async (code: string): Promise<CustomerLookup> => {
    const response = await apiClient.get<ApiResponse<CustomerLookup>>(`/points/lookup?code=${encodeURIComponent(code)}`);
    return response.data!;
  },

  assignPoints: async (loyaltyCode: string, points: number, description?: string): Promise<PointsTransactionResult> => {
    const response = await apiClient.post<ApiResponse<PointsTransactionResult>>('/points/assign', {
      loyaltyCode,
      points,
      description,
    });
    return response.data!;
  },

  deductPoints: async (loyaltyCode: string, points: number, description?: string): Promise<PointsTransactionResult> => {
    const response = await apiClient.post<ApiResponse<PointsTransactionResult>>('/points/deduct', {
      loyaltyCode,
      points,
      description,
    });
    return response.data!;
  },
};
